import { IconButton, Toolbar, Typography } from "@material-ui/core";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Skeleton from "@material-ui/lab/Skeleton";
import { FC } from "react";
import { useHistory } from "react-router";

import useStyles from "./Header.styles";


interface HeaderProps {
    title?: string;
}

const Header: FC<HeaderProps> = ({ title, children }) => {
    const classes = useStyles();
    const history = useHistory();

    return (
        <div className={classes.header}>
            <Toolbar>
                <IconButton
                    id="header_back-button"
                    data-testid="header_back-button"
                    edge="start"
                    onClick={() => history.push("/alerts")}
                >
                    <KeyboardBackspaceIcon />
                </IconButton>
                {title ?
                    <Typography variant="h6" className={classes.title}>{title}</Typography>
                    :
                    <Skeleton height={25} width={200} className={classes.title} />
                }
                {children}
            </Toolbar>
        </div>
    );
};

export default Header;
